import React from "react";
import {
  Button,
  Modal,
  Text,
  Box,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
} from "@chakra-ui/react";

function SuccessModal({ isOpen, setIsOpen, loanRequest }) {
  return (
    <Modal
      isCentered
      onClose={() => setIsOpen(!isOpen)}
      isOpen={isOpen}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Box>
            <Flex justify="center" align="center" direction="column" p="20px">
              <Text color="#5B2E4F" fontWeight="700" fontSize="20px">
                SUCCESS!
              </Text>

              <Text p="20px 0px" fontSize="16px">
                You have successfully made changes to {loanRequest.first_name}{" "}
                {loanRequest.last_name}'s instant loan request.
              </Text>

              <Button
                onClick={() => window.location.reload()}
                alignItems="center"
                bg="#5B2E4F"
                color="white"
                opacity={"1px"}
                fontSize="12px"
                fontWeight="500"
                fontFamily="satoshiBold"
                p="13px 35px"
              >
                DONE
              </Button>
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default SuccessModal;
